module.exports = require('portal/directives/NavBarCtrlPolicyholder')